export const ProductCategories = () => ({
  data: [
    { id: "1", value: "bags" },
    { id: "2", value: "shoes" },
    { id: "3", value: "hair creams" },
    { id: "4", value: "earrings" },
    { id: "5", value: "clothes" },
    { id: "6", value: "jeans" },
    { id: "7", value: "phones" },
    { id: "8", value: "refrigerators" },
    { id: "9", value: "tv" },
    { id: "9", value: "underwear" },
    { id: "10", value: "belts" },
    { id: "11", value: "fashion" },
    { id: "12", value: "foot wears" }
  ]
});
